import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatosAdicionalesComponent } from './datos-adicionales/datos-adicionales.component';
import { DatosPagosComponent } from './datos-pago/datos-pago.component';
import { GridComponent } from './grid/grid.component';
import { InputSearchComponent } from './input-search/input-search.component';
import { NumericKeyboardComponent } from './numeric-keyboard/numeric-keyboard.component';
import { PaginationButtonsComponent } from './pagination-buttons/pagination-buttons.component';
import { LoadingModule } from 'ngx-loading';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { TabsModule, ModalModule } from 'ngx-bootstrap';
import { NguiDatetimePickerModule } from '@ngui/datetime-picker';

@NgModule({
  imports: [
    CommonModule,
    LoadingModule.forRoot({
      backdropBorderRadius: '5px',
      fullScreenBackdrop: true
    }),
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    TabsModule,
    NguiDatetimePickerModule,
    ModalModule
  ],
  declarations: [
    DatosAdicionalesComponent,
    DatosPagosComponent,
    GridComponent,
    InputSearchComponent,
    NumericKeyboardComponent,
    PaginationButtonsComponent
  ],
  exports: [
    DatosAdicionalesComponent,
    DatosPagosComponent,
    GridComponent,
    InputSearchComponent,
    NumericKeyboardComponent,
    PaginationButtonsComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
})
export class ControlsModule { }



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/controls/controls.module.ts